import { Styles } from 'shared/types';

export const Main: Styles = {
  mt: 0,
  mb: 8,
  '&&': {
    px: 4,
  },
};
